import { gql } from 'react-apollo';

export const getEvangelists = gql`
  query getEvangelists {
    evangelists {
      id
      name
      passwordCreated: password_created
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churches/queries/getEvangelists.js